// Subtle dotted handball-court line art, used as the backdrop on the login art panel.
interface CourtArtProps {
  opacity?: number;
  stroke?: string;
  className?: string;
}

export function CourtArt({ opacity = 0.12, stroke = 'currentColor', className }: CourtArtProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 1200 600"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
    >
      <g fill="none" stroke={stroke} strokeWidth="1.2" opacity={opacity}>
        <rect x="40" y="40" width="1120" height="520" rx="12" />
        <line x1="600" y1="40" x2="600" y2="560" />
        <circle cx="600" cy="300" r="40" />
        <path d="M40 300 a260 260 0 0 1 260 -260 V40 H40 z" opacity="0.5" />
        <path d="M40 300 a260 260 0 0 0 260 260 V560 H40 z" opacity="0.5" />
        <path d="M1160 300 a260 260 0 0 1 -260 260 V560 H1160 z" opacity="0.5" />
        <path d="M1160 300 a260 260 0 0 0 -260 -260 V40 H1160 z" opacity="0.5" />
        <path d="M40 220 a380 380 0 0 1 380 -180 H400" strokeDasharray="6 6" opacity="0.4" />
        <path d="M40 380 a380 380 0 0 0 380 180 H400" strokeDasharray="6 6" opacity="0.4" />
        <path d="M1160 220 a380 380 0 0 0 -380 -180 H800" strokeDasharray="6 6" opacity="0.4" />
        <path d="M1160 380 a380 380 0 0 1 -380 180 H800" strokeDasharray="6 6" opacity="0.4" />
      </g>
    </svg>
  );
}
